import React from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { model, gtechurl, qrcodeurl, fblink, adsofturl, miurl } from '../config/config';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import  { useEffect, useState } from 'react';
import Card from "../components/Card";

export default function CardDetails() {

const [content, setContent] = useState([]);

const navigate = useNavigate();
const handleClose = () => {
   navigate(-parseInt(localStorage.getItem("attempts")))
  };
  
const [calist, setcalist] = React.useState(); 


    const  selectedCardId  = JSON.parse(localStorage.getItem("selectedCard"));
	
	let giffinalurl = "";
	let gifendurl = "";
	let binfinalurl = "";
	let binendurl = "";
	let binindexendurl = "";
	var name = selectedCardId.name;
	var fileid = selectedCardId.fileid;
	var language = selectedCardId.language;
	var imgurl = selectedCardId.imgurl;
	var author = selectedCardId.author;
	
	var catList = [];
	var qrmodel = ["gtr4","balance","active"];
	
	
	let wfheight = 0;
	if( model.includes("gtr4") || model.includes("balance") || model.includes("active"))
	{
		wfheight = 180;
	}else{
		wfheight = 300;
	}
	
	var modelarr = ["gtr3","gtr3pro","gts3","trex2","gts4","gtr4","gts4mini","aband7","falcon","gtrmini","cheetah","cheetahpro","cheetahsq","active","activee","balance","bip5","aband7"];
	var modelbiparr = ["bip","bips","bipu","bip3","bip5"];
	var extension = modelarr.includes(model) ? "zip" : "bin";
	if( model === "verge" || model === "stratos" )
		  extension = "wfz";
	
	switch(model) {
	  case "mb6":
	  case "mb7":
	  case "mb8":
			giffinalurl = adsofturl;
			binfinalurl = adsofturl
		break;
	 case "mb4":
			giffinalurl = gtechurl;
			binfinalurl = miurl
		break;	
	  default:
		    giffinalurl = gtechurl;
			binfinalurl = gtechurl
	}
	
	switch(model) {
	   case "bip": case "bips": case "bip3": case "bipu": case "bip5": 
			gifendurl = `wfimg/preview${fileid}.gif`;
			binendurl = `wfpib/${fileid}.${extension}`;
		break;
	  case "mb5": case "mb6": case "mb7": case "mb8": 
			gifendurl = `${model}/${model}_${fileid}.gif`;
			binendurl = `${model}bin/${model}_${fileid}.${extension}`;
		break;	
	  case "mb4":
			gifendurl = `${model}/${model}_${fileid}.gif`;
			binendurl = `files/${model}/${model}_${fileid}.${extension}`;
		break;	
	  default:
		    gifendurl = `${model}/images/${model}_${fileid}.gif`;
			binendurl = `${model}/${extension}/${model}_${fileid}.${extension}`;
	}
	
  const fetchAuthWF = async () => {
    const { data } = await axios.get(`${fblink}/watchface/${model}.json?orderBy="author"&startAt="${author}"&endAt="${author}"&limitToFirst=50`);
	
	if(data != null){
		let arrayOfObjects = Object.keys(data).map(key => {
		let ar = data[key]
		ar.key = key
		return ar})
		setContent(arrayOfObjects);
	}else{
		setContent([]);
	}
	console.log("fetchAuthWF");
    }
  
   useEffect(() => {
		fetchAuthWF();   
    }, []) 

 
   function getIndexVal()
   {
	   var myindex = catList.map(e => e.value).indexOf(calist);
		if( imgurl !== "" &&  imgurl !== undefined){
			if(myindex === -1){
				myindex = 0;
			}
		}
		return myindex;
   }
	const downloadFilenew = () => {

		var index = catList.map(e => e.value).indexOf(calist);
		if( imgurl !== "" &&  imgurl !== undefined){
			if(index === -1){
			index = 0;
			}
		}
		  switch(model) {
		   case "bip": case "bips": case "bip3": case "bipu": case "bip5": 			
				binindexendurl = `wfpib/${fileid}.${extension}`;
			break;
		  case "mb6": case "mb7": case "mb8": 			
				binindexendurl = `${model}bin/${model}_${fileid}_${index}.${extension}`;
			break;	
		  case "mb5": 
				binindexendurl = `${model}bin/${model}_${fileid}.${extension}`;
				break;
		  case "mb4":			
				binindexendurl = `files/${model}_${fileid}.${extension}`;
			break;	
		  default:		    
				binindexendurl = `${model}/${extension}/${model}_${fileid}_${index}.${extension}`;
		}
		
		  if(index === -1)
			window.location.href =  `${binfinalurl}${binendurl}`;
		  else
			window.location.href =  `${binfinalurl}${binindexendurl}`;
    }

	if( imgurl !== "" &&  imgurl !== undefined){	
	   
		catList = [];	
		imgurl.split(",").forEach(function(element) {
			catList.push({ label:element, value: element })
		});
	}
	
	
    return (

	<div className='parent-modal'>
	
		<AppBar sx={{ position: 'relative' }}>
          <Toolbar>

            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {name}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
		
			<div className='modal'>
            <div className='modal-left'>
			
              <img src={`${giffinalurl}${gifendurl}`} alt={name}  height = {`${wfheight}`} />
			  
            </div>
            <div className='modal-right'>

              <div className='title'>
                <Typography gutterBottom variant="h4" component="h4">
                  <span>{name}</span>
                  <span className='op8'>&nbsp; ( by {author})</span>
                </Typography>					
              </div>

              <div className='overview'>
                <Typography gutterBottom variant="h6" component="h6" mt={4}>
				Supported watch : Amazfit {model.toUpperCase()}
                </Typography>
                <Typography gutterBottom variant="h6" component="h6" mt={4}>
				Language : {language}
                </Typography>
				
				<br/>
              </div>
			   <div className='download'>
			   
			   { imgurl === ""  ? 
			   
					( 	   <Button variant="contained" onClick={() => downloadFilenew()}>Download</Button>)
					:
					(
							<div className='multifile'>
						   <TextField
								  id="selectsubject"
								  select
								  defaultValue= {imgurl ? catList[0].value : ""}
								  helperText="Choose language/color/type"
								  onChange={(e) => setcalist(e.target.value)}
								>
							  {catList.map((option) => (
								<MenuItem key={option.value} value={option.label} >
								  {option.label}
								</MenuItem>
								))}
							</TextField>
							<br/>
							<br/>
							<Button variant="contained" onClick={() => downloadFilenew()}>Download</Button>
							</div>
					)
			   }
				</div>
            </div>
			
			{qrmodel.includes(model) ? 
					( <div className='qrcode' style={{marginRight: 100, marginTop: 30}}  >
								 
									QR Code for installation through Zepp 'Scan' option <a href="/scanguide" style={{color : '#FF0000'}}>help</a>

									<br/>
								  <br/>
								<img src={ getIndexVal() === -1 ? `${qrcodeurl}${model}/${model}_${fileid}.zpk` : `${qrcodeurl}${model}/${model}_${fileid}_${getIndexVal()}.zpk` } />	
						</div>)
				   :
				   (
				   <div className='qrcode'>
				   </div>
				   )
			}
          </div>
		
		<Typography gutterBottom variant="h6" component="h6" mt={4} textAlign="center">
				Watch faces by {author}
         </Typography>
		<div className="card-grid">
        {
          content && content.map(item => {
            return <Card key={item.fileid} {...item} binfile="name" />
          })

        }
		</div>
	
	</div>
	   
	   
	   
    )
  
}
